<div class="pb-0 modal-body">
  <div [innerHTML]="message | translate | safeHtml"></div>
</div>
<div class="pt-0 modal-footer justify-content-center">
  <button class="btn btn-primary" type="submit" (click)="activeModal.close('Save click')">
    {{ 'Close' | translate }}
  </button>
</div>
